// src/features/agent-builder/components/MasterAgentArchitectTeaser.tsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Tooltip } from '@dopomogai/ui';
import { renderIcon } from '@dopomogai/utils'; // Your icon utility
import clsx from 'clsx';

export const MasterAgentArchitectTeaser: React.FC = () => {
  const { t } = useTranslation('agentBuilder');

  return (
    <div className={clsx(
      "p-6 mb-8 bg-gradient-to-br from-slate-100 via-slate-50 to-gray-100",
      "border-2 border-slate-300 border-dashed rounded-xl shadow-lg",
      "opacity-80 cursor-default" // Visually indicate it's a teaser / not yet active
    )}>
      <div className="flex flex-col sm:flex-row items-center sm:items-start gap-5 text-center sm:text-left">
        <div className="flex-shrink-0 p-3 bg-white rounded-full border-2 border-slate-400 shadow-md">
          {renderIcon('braincircuit', { size: 36, className: "text-slate-600" })} {/* 'braincircuit' or 'brain' */}
        </div>
        <div className="flex-grow">
          <h3 className="text-xl font-bold text-slate-700">
            {/* i18n: agentBuilder.step5.masterAgent.title = "Master Agent Architect" */}
            {t('step5.masterAgent.title')}
          </h3>
          <p className="mt-1.5 text-sm text-slate-600 leading-relaxed max-w-xl mx-auto sm:mx-0">
            {/* i18n: agentBuilder.step5.masterAgent.description = "The Master Agent can analyze your entire agent configuration, suggest improvements, and even create other agents to help you achieve your goals." */}
            {t('step5.masterAgent.description')}
          </p>
          <div className="mt-4">
            <Tooltip
              textKey="agentBuilder:step5.masterAgent.summonTooltip"
              // text={t('step5.masterAgent.summonTooltip')} // "Get a comprehensive AI review of your agent setup."
            >
              <Button
                textKey="agentBuilder:step5.masterAgent.summonButton"
                // text={t('step5.masterAgent.summonButton')} // "[✨ Summon Architect (Coming Soon)]"
                variant="secondary" // Or a custom teaser style
                size="md" // Make it a bit more prominent
                disabled
                icon={renderIcon('sparkles', { size: 16 })} // 'sparkles' or 'ai'
                className="opacity-90 cursor-not-allowed border-slate-400 text-slate-600 hover:border-slate-500"
              />
            </Tooltip>
          </div>
        </div>
      </div>
    </div>
  );
};